import { EuroOutlined, FileExcelOutlined, FilePdfOutlined, UploadOutlined } from '@ant-design/icons';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { EmptyButton, GRID_LG, GRID_MD, RowExt } from '../../../styles';
import { BLACK, BLUE, RED } from '../../../styles/colors';
import { ButtonFullWidth, LinkFullWidth } from '../../../styles/ui';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { HomeMenuWrapper, HomeTitleWrapper } from '../HomeUI/HomeUI';

const MenuTools = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  return (
    <RowExt marginTop={width < GRID_LG ? 24 : 0} marginBottom={width < GRID_LG ? 48 : 0}>
      <HomeTitleWrapper
        borderColor={RED}
        title={t('home.menu.title2')}
        level={width <= GRID_MD ? 4 : 5}
      />
      <HomeMenuWrapper>
        <LinkFullWidth
          to={{ pathname: '/importExcel' }}
        >
          <EmptyButton
            style={{ width: '100%' }}
            icon={<FileExcelOutlined />}
            dotted
            disabled
          >
            {t('home.menu.excel')}
          </EmptyButton>
        </LinkFullWidth>
      </HomeMenuWrapper>
      <HomeMenuWrapper>
        <input
          type="file"
          style={{ display: 'none' }}
          accept="application/json"
        />
        <ButtonFullWidth
          type="dashed"
          icon={<UploadOutlined />}
          disabled
        >
          {t('home.menu.upload')}
        </ButtonFullWidth>
      </HomeMenuWrapper>
      <HomeMenuWrapper>
        <LinkFullWidth
          to={{ pathname: '/currency' }}
        >
          <EmptyButton
            style={{ width: '100%' }}
            icon={<EuroOutlined />}
            dotted
            disabled
          >
            {t('home.menu.curr')}
          </EmptyButton>
        </LinkFullWidth>
      </HomeMenuWrapper>
    </RowExt>
  );
};

export default MenuTools;
